import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var MotionReduce = /*#__PURE__*/function () {
  function MotionReduce() {
    _classCallCheck(this, MotionReduce);
    this.factor = 4;
    this.value = true;
  }
  _createClass(MotionReduce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.factor !== undefined) {
        this.factor = data.factor;
      }
      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }]);
  return MotionReduce;
}();